import { ApiError, requestJson, type ApiEnvelope } from '@shared/api/http';
import type { GroupSearchResult } from './types';

function ensureSuccess<T>(body: ApiEnvelope<T>, fallbackMessage: string): ApiEnvelope<T> {
  if (body.status && body.status !== 'Success') {
    throw new ApiError(body.message ?? fallbackMessage, body.statusCode ?? 500, body);
  }
  return body;
}

function withQuery(path: string, query: Record<string, string | number | undefined>) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== '') {
      params.set(key, String(value));
    }
  }
  const suffix = params.toString();
  return suffix ? `${path}?${suffix}` : path;
}

export async function searchGroups(
  keyword: string,
  baseUrl?: string,
  page = 1,
  limit = 20,
): Promise<GroupSearchResult[]> {
  const body = await requestJson<ApiEnvelope<Record<string, unknown>>>(
    withQuery('/group/search', { keyword, page, limit }),
    { baseUrl },
  );

  const success = ensureSuccess(body, 'Search groups failed');
  const payload = success.data ?? {};
  const rawGroups = Array.isArray(payload.groups) ? payload.groups : [];

  return rawGroups.map((entry) => {
    const group = entry as Record<string, unknown>;
    return {
      id: Number(group.id ?? 0),
      name: String(group.name ?? ''),
      avatarUrl: String(group.avatar ?? ''),
      creator: Number(group.creator ?? 0),
      type: Number(group.type ?? 0),
      memberCount: Number(group.member_count ?? 0),
      status: Number(group.status ?? 0),
      createdAt: Number(group.created_at ?? 0),
      updatedAt: Number(group.updated_at ?? 0),
    };
  });
}
